import base from '../httpApi/base'; // 导入接口域名列表
import axios from '../httpApi/http'; // 导入http中创建的axios实例
const bannerApi = {
  getBanner(params) {
    return axios.get(`${base.dev}/services/app/Banner/GetAll`, { params })
  },
  BannerCk(params) {
    return axios.post(`${base.dev}/services/app/Banner/UpdateClick`, params)
  },
  AdminSystemNoticeGetAll(params) {
    return axios.get(`${base.dev}/services/app/AdminSystemNotice/GetAll`, { params })
  },
  AdminSystemNoticeCreate(params) {
    return axios.post(`${base.dev}/services/app/AdminSystemNotice/Create`, params)
  },
  AdminSystemNoticeUpdate(params) {
    return axios.post(`${base.dev}/services/app/AdminSystemNotice/Update`, params)
  },
  AdminSystemNoticeGet(params) {
    return axios.get(`${base.dev}/services/app/AdminSystemNotice/Get`, { params })
  },
  SystemNoticeGetAll(params) {
    return axios.get(`${base.dev}/services/app/SystemNotice/GetAll`, { params })
  },
}
export default bannerApi


// WEBPACK FOOTER //
// ./src/api/Banner/BannerApi.js